import AskEmail from './AskEmail';
import ConfirmCode from './ConfirmCode';
import ResetPassword from './ResetPassword';

export default {
  step1: AskEmail,
  step2: ConfirmCode,
  step3: ResetPassword,
}